import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { inject, isDevMode, provideAppInitializer } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideTransloco } from '@jsverse/transloco';
import { provideQuillConfig } from 'ngx-quill';

import { APPLICATION_ROUTES } from './app-routes';
import { AuthService } from './core/auth/auth.service';
import { initFactory } from './core/factory/init.factory';
import { globalQuillConfig } from './quill-config';
import { errorInterceptorFn } from '@shared/services/error-interceptor.service';
import { AppState } from './store/states/app.state';
import { TranslocoHttpLoader } from './transloco-loader';

export const appConfig = {
  providers: [
    provideRouter(
      APPLICATION_ROUTES,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top'
      }),
      withComponentInputBinding()
    ),
    provideHttpClient(withInterceptors([errorInterceptorFn])),
    provideQuillConfig(globalQuillConfig),
    provideMomentDateAdapter(),
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      const appState = inject(AppState);
      initFactory(authService, appState);
    }),
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    provideTransloco({
      config: {
        availableLangs: ['en', 'de'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode()
      },
      loader: TranslocoHttpLoader
    })
  ]
};
